/*! IG Homepage DRAFT soft product-cube fade — theme 190828740792 only
 * Spec: 3 Tommy rows; 1 cube/row at a time; interval 4.5s; row stagger 1.5s;
 * preload next alt; pause hover/focus; respect prefers-reduced-motion; lazy below-fold.
 */
(function () {
  'use strict';
  if (window.__igSoftFadeInit) return;
  window.__igSoftFadeInit = true;

  var INTERVAL = 4500;
  var STAGGER = 1500;
  var HOLD_MS = 2200;

  function reducedMotion() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  function preload(src) {
    if (!src) return;
    var img = new Image();
    img.decoding = 'async';
    img.src = src;
  }

  function fadeCubes(row) {
    return Array.prototype.slice
      .call(row.querySelectorAll('.ig-tj-cube .ig-tj-media[data-ig-sf="1"]'))
      .map(function (media) { return media.closest('.ig-tj-cube'); })
      .filter(Boolean);
  }

  function altSrc(cube) {
    var b = cube && cube.querySelector('.ig-tj-img--b');
    return b ? (b.currentSrc || b.getAttribute('src')) : null;
  }

  function setOn(cube, on) {
    if (!cube) return;
    cube.classList.toggle('is-ig-sf-on', !!on);
  }

  function startRow(row, delay) {
    var cubes = fadeCubes(row);
    if (!cubes.length) return;

    var i = 0;
    var paused = false;
    var timer = null;
    var holdTimer = null;
    var active = null;
    var visible = false;
    var hoverDepth = 0;

    function clearTimers() {
      if (timer) { clearTimeout(timer); timer = null; }
      if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; }
    }

    function schedule(ms) {
      clearTimers();
      timer = setTimeout(tick, ms);
    }

    function canRun() {
      return visible && !paused && hoverDepth === 0 && !reducedMotion() && !document.hidden;
    }

    function pause() {
      paused = true;
      clearTimers();
    }

    function resume() {
      paused = false;
      if (canRun() && !timer) schedule(500);
    }

    function tick() {
      if (!canRun()) return;
      setOn(active, false);
      active = cubes[i % cubes.length];
      var next = cubes[(i + 1) % cubes.length];
      i = (i + 1) % cubes.length;
      preload(altSrc(next));
      setOn(active, true);
      holdTimer = setTimeout(function () {
        setOn(active, false);
        active = null;
      }, HOLD_MS);
      schedule(INTERVAL);
    }

    cubes.forEach(function (cube) {
      cube.addEventListener('pointerenter', function () {
        hoverDepth++;
        pause();
      });
      cube.addEventListener('pointerleave', function () {
        hoverDepth = Math.max(0, hoverDepth - 1);
        if (hoverDepth === 0) resume();
      });
      cube.addEventListener('focusin', function () {
        hoverDepth++;
        pause();
      });
      cube.addEventListener('focusout', function () {
        hoverDepth = Math.max(0, hoverDepth - 1);
        if (hoverDepth === 0) resume();
      });
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        clearTimers();
      } else if (canRun()) {
        schedule(400);
      }
    });

    function kick() {
      if (!canRun()) return;
      preload(altSrc(cubes[i % cubes.length]));
      preload(altSrc(cubes[(i + 1) % cubes.length]));
      if (!timer && !active) schedule(delay);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          visible = !!(en.isIntersecting && en.intersectionRatio > 0.05);
          if (visible) kick();
          else {
            clearTimers();
            setOn(active, false);
            active = null;
          }
        });
      }, { root: null, rootMargin: '140px 0px', threshold: [0, 0.05, 0.2] });
      io.observe(row);
    } else {
      visible = true;
      kick();
    }
  }

  function boot() {
    if (reducedMotion()) return;
    var rows = document.querySelectorAll('.ig-tj-grid[data-ig-sf-row="1"]');
    if (!rows.length) return;
    Array.prototype.forEach.call(rows, function (row, idx) {
      startRow(row, idx * STAGGER + 700);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
